/* eslint-disable */
import http from "../../api/http"; /** file configured to make requests to the server with fetch */
import auth from "../../auth";
var _ = require("lodash");
const actions = {
     FetchListVolume({commit},payload) {
        return http.get("volumes", payload).then(response => {
            if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                commit('SetVolume',response.DATA);
            } 
            return response;
        });
    }
};
export default actions;